import "./DashboardMobileViewComponent.scss";
import template from "./DashboardMobileViewComponent.html";
import {IAngularEvent, IComponentOptions, IOnDestroy, IOnInit, ITimeoutService} from "angular";
import {StringKeyed} from "../../../../types/GenericTypes";
import {DashboardViewStore} from "../../store/DashboardViewStore";
import {AddDashboardService} from "../../dialog/add-dashboard/service/AddDashboardService";
import {StateService} from "@uirouter/core";
import {Observable, ReplaySubject} from "rxjs";
import {
    DashboardConfiguration,
    DashboardSummaries,
    DashboardSummary,
    widgetCount
} from "../../models/DashboardViewConfiguration";
import {ObjectUtil} from "../../../../js/util/ObjectUtil";

export const MobileView = "tfOmsDashboardMobileView";

export function mobileView(): IComponentOptions {
    return {
        template,
        bindings: {
            activeTab: "<"
        },
        controllerAs: "ctrl",
        controller: DashboardMobileViewComponentController
    };
}

export class DashboardMobileViewComponentController implements IOnInit, IOnDestroy {

    /** @input */
    public set activeTab(tab: number | null) {
        if (tab != null) {
            this.selectDashboard(tab);
        }
    }

    public editActive = false;
    public selectedTab = 1;

    public readonly widgetCount$: Observable<number>;
    public readonly dashboards$: Observable<DashboardSummaries>;

    public readonly settings: StringKeyed;

    private readonly destroyed$ = new ReplaySubject<boolean>(1);

    /** @ngInject */
    public constructor(private readonly $timeout: ITimeoutService,
                       private readonly dashboardViewStore: DashboardViewStore,
                       private readonly addDashboardService: AddDashboardService,
                       private readonly $state: StateService,
                       private readonly confirmationService: ConfirmationService) {
        this.widgetCount$ = this.buildWidgetCount();
        this.dashboards$ = this.buildDashboards();
        this.settings = this.buildSettings();
    }

    private buildDashboards(): Observable<DashboardSummaries> {
        return this.dashboardViewStore
                   .dashboards
                   .takeUntil(this.destroyed$)
                   .publishReplay(1)
                   .refCount();
    }

    private buildWidgetCount(): Observable<number> {
        return this.dashboardViewStore
                   .currentDashboard
                   .distinctUntilChanged(ObjectUtil.simpleEquals)
                   .map((d) => d.layout)
                   .map((l) => l.type)
                   .map((t) => widgetCount(t))
                   .startWith(1)
                   .distinctUntilChanged()
                   .publishReplay(1)
                   .refCount();
    }

    private buildSettings(): StringKeyed {
        return {
            autoplay: false,
            arrows: false,
            dots: true,
            draggable: true,
            mobileFirst: true,
            infinite: false,
            event: {
                init: (event: JQueryEventObject, slick: any) => {
                    console.debug("@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@");
                },
                beforeChange: (event: JQueryEventObject, slick: any, currentSlide: number, nextSlide: number) => {
                    console.debug("##########################################################");
                }
            }
        };
    }

    public $onInit() {
        this.watchDashboardNumberChange();
        this.watchForUnavailableDashboard();
    }

    private selectDashboard(tab: number) {
        this.dashboardViewStore.select(tab);
        this.selectedTab = tab;
    }

    /*
     * This is for when we create a new Dashboard and select it, otherwise it does nothing
     * as we are already on that route
     */
    private watchDashboardNumberChange() {
        this.dashboardViewStore
            .currentDashboardNumber
            .takeUntil(this.destroyed$)
            .distinctUntilChanged()
            .subscribe((dashboard) => {
                this.$state.go(".", {view: dashboard});
            });
    }

    /* If we delete a dashboard or are now otherwise on the incorrect dashboard number then we select the last available */
    private watchForUnavailableDashboard() {
        const source$ = Observable.combineLatest(this.dashboardViewStore.currentDashboardNumber,
                                                 this.dashboardViewStore.dashboards);

        source$.filter(([current, dashboards]) => current > dashboards.length)
               .map(([_, dashboards]) => dashboards.length)
               .subscribe((select) => this.selectDashboard(select));
    }

    public summaryTrackBy(summary: DashboardSummary): string {
        return summary.order + summary.name;
    }

    public async openAddDashboard() {
        try {
            const dashboard = await this.addDashboardService.open();
            this.dashboardViewStore.addDashboard(dashboard);
        } catch (e) {

        }
    }

    public async removeDashboard($event: IAngularEvent, dashboard: number) {
        $event.preventDefault();
        if ($event.stopPropagation != null) {
            $event.stopPropagation();
        }
        try {
            await this.confirmationService.confirm("deleteDashboard");
            this.dashboardViewStore.removeDashboard(dashboard);
        } catch (e) {

        }
    }

    public $onDestroy() {
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }

}
